import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import useAuth from "hooks/useAuth"

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";


function ModalUpdateSell(props) {

    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const [br, setBR] = React.useState(false);

    const [products, setProducts] = useState([]);
    const [clients, setClients] = useState([]);
    const [productId, setProductId] = useState(props.props.id_product);
    const [clientId, setClientId] = useState(props.props.id_client);
    const [amount, setAmount] = useState(props.props.amount);
    const [discount, setDiscount] = useState(props.props.discount);
    const [price, setPrice] = useState(parseFloat(props.props.price));
    const [nf, setNf] = useState(props.props.nf);
    const [practicePrice, setPraticePrice] = useState(props.props.practice_price);
    const [startDate, setStartDate] = useState(new Date(props.props.date_of_sell));
    const [controlSnack, setControlSnack] = useState(false);

    const { storageId } = useAuth();

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        loadProducts();
        loadClients();
    }, []);

    async function loadProducts() {
        const response = await api.get('/product/admin/' + storageId);
        setProducts(response.data);
    }

    async function loadClients() {
        const response = await api.get('/client/sell/' + storageId)
        setClients(response.data);
    }

    async function handleEditSell(e) {
        e.preventDefault();

        if (amount === undefined || amount <= 0) {
            return alert('Quantidade inválida');
        }
        if (practicePrice === undefined || practicePrice <= 0) {
            return alert('Preço praticado inválido');
        }
        if (nf === undefined || nf <= 0) {
            return alert('Nota fiscal inválida');
        }
        let response;
        if (price === undefined) {
            response = await api.put('/sell/' + props.props.id, {
                nf: nf,
                practice_price: practicePrice,
                amount: amount,
                date_of_sell: startDate,
                discount: discount ? discount : 0,
                id_admin: storageId,
                id_product: productId ? productId : products[0].id,
                id_client: clientId ? clientId : clients[0].id
            });
        } else {
            response = await api.put('/sell/' + props.props.id, {
                nf: nf,
                practice_price: practicePrice,
                amount: amount,
                price: price,
                date_of_sell: startDate,
                discount: discount ? discount : 0,
                id_admin: storageId,
                id_product: productId ? productId : products[0].id,
                id_client: clientId ? clientId : clients[0].id
            });
        }


        if (response.status === 200) {
            setControlSnack(true);
            props.onHide();
            if (!props.dashboard) {
                props.loadSell();
            }
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Venda
          </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditSell}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group controlId="formGridNF">
                            <Form.Label>NF</Form.Label>
                            <Form.Control onChange={event => setNf(event.target.value)} value={nf} type="number" placeholder="Nota fiscal da venda" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} value={productId} as="select" defaultValue="Choose...">
                                {products.map(product => (
                                    <option key={String(product.id)} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} value={amount} type="number" placeholder="Quantidade de produtos" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPrice">
                            <Form.Label>Preço do produto</Form.Label>
                            <Form.Control onChange={event => setPrice(event.target.value)} type="double" placeholder="Caso vazio será o padrão" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPracticePrice">
                            <Form.Label>Preço praticado</Form.Label>
                            <Form.Control onChange={event => setPraticePrice(event.target.value)} value={practicePrice} type="number" placeholder="Preço de venda do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridDiscount">
                            <Form.Label>Desconto</Form.Label>
                            <Form.Control onChange={event => setDiscount(event.target.value)} type="double" placeholder="Caso tenha desconto" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridClients">
                            <Form.Label>Clientes</Form.Label>
                            <Form.Control onChange={event => setClientId(event.target.value)} value={clientId} as="select" defaultValue="Choose...">
                                {clients.map(client => (
                                    <option key={String(client.id)} value={client.id}>{client.social_reason}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridDate">
                            <Form.Label>Data</Form.Label>
                            <div>
                                <DatePicker
                                    selected={startDate}
                                    onChange={date => setStartDate(date.withoutTime())}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation />
                            </div>
                        </Form.Group>
                    </Form.Row>

                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit" onClick={controlSnack ? () => showNotification("br") : () => showNotification("nf")}>
                            Editar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Venda modificada com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateSell;